module.exports = __webpack_public_path__ + "img/bg-2-m.8f966ed4.jpg";